import { render } from "./minorQuestion.view.vue?vue&type=template&id=7650e010&scoped=true&ts=true"
import script from "./minorQuestion.view.vue?vue&type=script&lang=ts"
export * from "./minorQuestion.view.vue?vue&type=script&lang=ts"

import "./minorQuestion.view.vue?vue&type=style&index=0&id=7650e010&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7650e010"]])

export default __exports__